var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SkuCommodityCode } from "./SkuCommodityCode";
export class AddSku {
  constructor(_data) {
    /**
     */
    __publicField(this, "CommodityCodes");
    /**
     */
    __publicField(this, "ItemIdentifier");
    /**
     */
    __publicField(this, "SkuId");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof AddSku
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.AddSku");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["CommodityCodes"] && _data["CommodityCodes"].constructor === Array) {
        this.CommodityCodes = [];
        for (let item of _data["CommodityCodes"]) {
          const commodityCodes_ = new SkuCommodityCode();
          this.CommodityCodes.push(commodityCodes_.init(item));
        }
      }
      this.ItemIdentifier = _data["ItemIdentifier"];
      this.SkuId = _data["SkuId"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    if (this.CommodityCodes && this.CommodityCodes.constructor === Array) {
      _data["CommodityCodes"] = [];
      for (let item of this.CommodityCodes) {
        _data["CommodityCodes"].push(item.toJSON());
      }
    }
    _data["ItemIdentifier"] = this.ItemIdentifier;
    _data["SkuId"] = this.SkuId;
    return _data;
  }
}
